import drawsData from './draws.json';
import winnersData from './winners.json';
import leaderboardData from './leaderboard.json';
import usersData from './users.json';

export function getDrawsByGameType(gameType) {
  const draws = drawsData.draws.filter(
    draw => draw.game_type === gameType && draw.status === 'active'
  );
  draws.sort((a, b) => new Date(a.draw_date) - new Date(b.draw_date));
  return draws;
}

export function getMainDraw(gameType) {
  const draws = getDrawsByGameType(gameType);
  return draws.length > 0 ? draws[0] : null;
}

export function getBonusDraws(gameType) {
  const draws = getDrawsByGameType(gameType);
  return draws.slice(1);
}

export function getAllDraws() {
  return drawsData.draws.filter(draw => draw.status === 'active');
}

export function getDrawById(id) {
  return drawsData.draws.find(draw => draw.id === id) || null;
}

export function getRecentWinners(limit = 5) {
  return drawsData.recentWinners.slice(0, limit);
}

export function getWinnersByGameType(gameType, limit = 5) {
  return drawsData.recentWinners
    .filter(winner => winner.game_type === gameType)
    .slice(0, limit);
}

export function getAllWinners() {
  return winnersData.winners;
}

export function getWinnersForGameType(gameType, limit = null) {
  const winners = winnersData.winners.filter(w => w.gameType === gameType);
  return limit ? winners.slice(0, limit) : winners;
}

export function getWinnersByYear(year) {
  return winnersData.winners.filter(w => w.year === year);
}

export function getWinnerStatistics(gameType = null) {
  if (gameType) {
    return winnersData.statistics[gameType] || null;
  }
  return winnersData.statistics;
}

export function getLeaderboardEntries(period = 'currentDraw', limit = 10) {
  const entries = period === 'yearly'
    ? leaderboardData.yearlyLeaders
    : leaderboardData.leaderboardEntries;
  return entries.filter(e => e.is_visible).slice(0, limit);
}

export function getOrganizationSupport(limit = 5) {
  return leaderboardData.organizationSupport.slice(0, limit);
}

export function getTestAccounts() {
  return usersData.testAccounts;
}

export function getUserProfiles() {
  return usersData.profiles;
}

export function getUserPurchaseHistory(userId) {
  return usersData.purchaseHistory[userId] || [];
}

export function getUserWinHistory(userId) {
  return usersData.winHistory[userId] || [];
}

export function getAdminCredentials() {
  return usersData.testAccounts.admin;
}
